﻿import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';
import { format } from 'common/functions/string';

export class WorkTrayViewNotFoundDialog implements IDialog {
    private dialogContent: JQuery;
    options: IDialogOptions;

    constructor(viewName: string, resources: IResourceProvider) {
        this.dialogContent = $('<div />').text(format(resources.getCoreString('MsgWorkTrayViewNotFound'), viewName));

        this.options = {
            title: resources.getCoreString('MsgWorkTrayViewNotFoundTitle'),
            width: 400,
            height: 200,
            dialogClass: 'wf-view-dialog',
            buttons: [
                { text: 'Ok', click: () => this.dialogContent.dialog('close') }
            ],
            create: () => $('.ui-dialog-buttonset > button', this.dialogContent.parent()).css('min-width', '50px')
        };
    }

    content(): JQuery {
        return this.dialogContent;
    }
}